import styled from "styled-components";

interface IStyledDeviceProps{
    index: any
}

export const DeviceStyle = styled.div<IStyledDeviceProps>`
    ${({theme, index}) => `
        padding: ${theme.uptimeSpace[3]}px 0;
        &:first-child {
            padding-top: ${index === 0 ? `${theme.uptimeSpace[6]}px`:`${theme.uptimeSpace[3]}px`};
        }
        .h-100 {
            height: 100%;
        }
        .card {
            display: flex;
        }
        .card img{
            max-height: 100px;
            max-width: 100%;
            width: auto;
        }
        .card .h-100 {
            justify-content: center;
        }
        
        .card-wrap {
            box-shadow: ${theme.uptimeSpace[2]}px ${theme.uptimeSpace[5]}px ${theme.uptimeSpace[15]}px ${theme.uptimeSpace[2]}px rgba(36, 14, 47, 0.06);
            border-radius: ${theme.uptimeSpace[6]}px;
            padding: ${theme.uptimeSpace[10]}px ${theme.uptimeSpace[8]}px;
            min-height: 162px;
        }
        
        .cardDetails {
            flex: 1;
            position: relative;
            padding: 0 0 0 ${theme.uptimeSpace[20]}px;
            
        }
        
        .cardDetails .device-card-configuration {
            display: flex;
            align-items: center;
            justify-content: left;
            font-size: ${theme.uptimeSpace[5]}px;
            flex-wrap: nowrap;
            margin-top: ${theme.uptimeSpace[6]}px;
            .device-health-icon {
                width: 20px !important;
                height: 20px !important;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
            }
        }
        
        .cardDetails .device-card-configuration .MuiSvgIcon-root {
            display: inline-block;
            width: ${theme.uptimeSpace[6]}px;
            height: ${theme.uptimeSpace[6]}px;
            margin-right: ${theme.uptimeSpace[2]}px;
        }
        
        .cardDetails .device-card-configuration .device-card-configuration-header {
            font-size: ${theme.uptimeFontSizes.desktop.fz2}px;
            line-height: ${theme.uptimeLineHeights.desktop.lh3}px;
            white-space: nowrap;
            margin-right: ${theme.uptimeSpace[4]}px;
            font-weight: 600;
        }
        
        .cardDetails .device-card-configuration .device-card-configuration-content {
            color: ${theme.uptimeColors.grayScales.darkerGray};
            word-break: break-all;
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-line-clamp: 1;
            white-space: nowrap;
            -webkit-box-orient: vertical;
            font-size: ${theme.uptimeFontSizes.desktop.fz2}px;
            line-height: ${theme.uptimeLineHeights.desktop.lh3}px;
        }
        
        .captionRegular {
            font-size: ${theme.uptimeFontSizes.desktop.fz2}px;
            line-height: ${theme.uptimeLineHeights.desktop.lh3}px;
            font-family: ${theme.uptimeFonts.primary}${theme.uptimeFonts.secondary && `,${theme.uptimeFonts.secondary}`} !important;
            text-transform: uppercase;
        }
        
        .heading5 {
            font-size: ${theme.uptimeFontSizes.desktop.fz7}px;
            line-height: ${theme.uptimeLineHeights.desktop.lh6}px;
            font-weight: normal;
            font-family: ${theme.uptimeFonts.primary}${theme.uptimeFonts.secondary && `,${theme.uptimeFonts.secondary}`} !important;
        }
        
        .eyebrow-ready-refresh {
            margin: 0 0 ${theme.uptimeSpace[4]}px;
        
        }
        
        img {
            display: block;
            width: 100%;
        }
        
        .cardButton {
            margin-top: ${theme.uptimeSpace[4]}px;
        }
        
        .MuiPopover-paper.MuiPaper-rounded {
            width: 185px;
        }

        @media (min-width: 960px){
            .heading5 {
                line-height: ${theme.uptimeLineHeights.desktop.lh5}px;
            }
        }

        @media (min-width: 769px) {
            .cardDetails {
                padding-left: ${theme.uptimeSpace[4]}px;   
            }

            .cardButton {
                display: flex;
                justify-content: end;
                margin-top: 0;
            }
        }
    `}
`;

export const IconHeaderStyle = styled.div`
    display: flex;
    align-self: center;
`;